<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>财务明细</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="formFilter" class="demo-form-inline">
                <el-form-item label="创建时间">
                    <el-date-picker
                        v-model="formFilter.daterange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="交易类型">
                    <el-select v-model="formFilter.type" placeholder="请选择交易类型">
                        <el-option
                            v-for="(item, index) in types"
                            :key="index"
                            :label="item"
                            :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box" style="">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="records"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        prop="order_no"
                        align="center"
                        label="交易流水号/结算批次号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="交易类型">
                        <template slot-scope="scope">
                            {{types[scope.row.type]}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="money"
                        align="center"
                        label="交易金额">
                    </el-table-column>
                    <el-table-column
                        prop="account_money"
                        align="center"
                        label="账户结余">
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :current-page="currentPage"
                        :page-size="10"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    name: 'Index',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            types: ['充值', '支付服务费', '支付平台服务费', '服务费退款', '平台服务费退款', '提现', '提现失败', '发放奖励'],
            formFilter: {
                daterange: [],
                start_time: '',
                end_time: '',
                type: ''
            },
            records: [],
            total_page: 1
        }
    },
    computed: {
        ...mapState({
            currentPage: 'curPage',
            condition: 'formFilter'
        })
    },
    mounted () {
        if (this.condition) {
            this.formFilter = this.condition
        }
        this.getCapital()
    },
    methods: {
        getCapital (page = this.currentPage) {
            this.$http.get('/api/user/account/capital', {
                params: {
                    type: this.formFilter.type,
                    page,
                    size: 10,
                    start_time: this.formFilter.start_time,
                    end_time: this.formFilter.end_time
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.records = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        onFilter () {
            this.formFilter.start_time = this.getDateFromRange(this.formFilter.daterange)[0]
            this.formFilter.end_time = this.getDateFromRange(this.formFilter.daterange)[1]
            this.$store.commit('changeCondition', this.formFilter)
            this.getCapital(1)
        },
        onPageChange (e) {
            this.$store.commit('changePage', e)
            this.getCapital(e)
        },
        getDateFromRange (d) {
            let daterange = !d ? [] : d
            let date0 = !(daterange[0] === '' || !daterange[0]) ? `${daterange[0].getFullYear()}-${daterange[0].getMonth() + 1}-${daterange[0].getDate()}` : ''
            let date1 = !(daterange[1] === '' || !daterange[1]) ? `${daterange[1].getFullYear()}-${daterange[1].getMonth() + 1}-${daterange[1].getDate()}` : ''
            return [date0, date1]
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";

    .data-overview {
        height: 78px;
    }
</style>
